var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":("" + _vm.urlParceiros + _vm.indicador),"target":"_blank"}},[_c('i',{staticClass:"mdi mdi-account-arrow-right text-secondary"}),_vm._v(" "+_vm._s(_vm.$t('comissoes.menu.favorecido.parceiros'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }